import { ceilNumber } from "@/utils/number";
import { FrameName } from "../config";
import { getStorageResourceMultiplier } from "../config/buildings";
import { type ResourceType } from "../config/resources";
import TileEntity from "../TileEntity";

class GreatWarehouseBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.GREAT_WAREHOUSE;

	public get storage(): Map<ResourceType, number> {
		const storage = new Map<ResourceType, number>(super.storage);

		// Apply upgrades for each resource in the storage map.
		for (const resource of storage.keys()) {
			let resourceStorage = (storage.get(resource) as number) || 0;
			resourceStorage *=
				1 +
				getStorageResourceMultiplier(
					this.getOwnNeighbourTileEntitiesByNeighbourFrameName(
						FrameName.STORAGE_OVERSEER,
						1,
					),
				);
			resourceStorage = ceilNumber(resourceStorage);
			storage.set(resource, resourceStorage);
		}

		return storage;
	}
}

export default GreatWarehouseBuildingTileEntity;
